// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-contact-jsx": function componentSrcPagesContactJsx() {
    return import("./../../src/pages/contact.jsx"
    /* webpackChunkName: "component---src-pages-contact-jsx" */
    );
  },
  "component---src-templates-cakes-page-jsx": function componentSrcTemplatesCakesPageJsx() {
    return import("./../../src/templates/CakesPage.jsx"
    /* webpackChunkName: "component---src-templates-cakes-page-jsx" */
    );
  },
  "component---src-templates-index-page-jsx": function componentSrcTemplatesIndexPageJsx() {
    return import("./../../src/templates/IndexPage.jsx"
    /* webpackChunkName: "component---src-templates-index-page-jsx" */
    );
  },
  "component---src-templates-message-page-jsx": function componentSrcTemplatesMessagePageJsx() {
    return import("./../../src/templates/MessagePage.jsx"
    /* webpackChunkName: "component---src-templates-message-page-jsx" */
    );
  },
  "component---src-templates-pastries-page-jsx": function componentSrcTemplatesPastriesPageJsx() {
    return import("./../../src/templates/PastriesPage.jsx"
    /* webpackChunkName: "component---src-templates-pastries-page-jsx" */
    );
  }
};